module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDE3IDE0Ij4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMy45MTloMi45OTN2NS45N0gwVjMuOTJ6bTIuOTk1LS4wMTVMNyAuOTI0djEyTDIuOTk1IDkuODgydi01Ljk4eiIvPgogICAgICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzIDYuMjU3bC0yLjA1LTIuMDUtLjc0My43NDNMMTIuMjU3IDdsLTIuMDUgMi4wNS43NDMuNzQzTDEzIDcuNzQzbDIuMDUgMi4wNS43NDMtLjc0M0wxMy43NDMgN2wyLjA1LTIuMDUtLjc0My0uNzQzTDEzIDYuMjU3eiIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/assets/volume/volume-0.svg
// module id = 1687
// module chunks = 1 2 3